/*
 * @Description:
 * @Date: 2022-06-20 11:29:02
 */
import http from '@/utils/http/axios';

enum Api {
  getCommonProtocol = '/common/protocol' //获取隐私和服务协议
}
export const getCommonProtocol = async (): Promise<
  Result<
    {
      title: string; //协议标题
      content: string; //协议内容
      takeEffectAt: string | number | Date; //生效时间
      releaseAt: string | number | Date; //发布时间（更新时间）
    }[]
  >
> => {
  return http.request({
    url: Api.getCommonProtocol,
    method: 'GET'
  });
};
